import { ReactNode } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';

interface INavSideBarNavigationBtn {
  children: ReactNode;
  to: string;
  associatedPaths?: string[];
  [key: string]: any;
}

export const NavSideBarNavigationBtn = ({ children, to, associatedPaths, ...restProps }: INavSideBarNavigationBtn) => {
  const { pathname } = useLocation();
  const isActive =
    pathname === to || (Array.isArray(associatedPaths) && associatedPaths.some((path) => path === pathname));

  return (
    <NavLink to={to} style={{ width: '100%' }}>
      <Button
        rightIcon={<BsArrowRight />}
        w='100%'
        justifyContent='flex-start'
        background={isActive ? 'base.700' : 'brand.offBlack'}
        borderRadius={10}
        px={6}
        minH={16}
        fontSize={14}
        color='white'
        _hover={{
          background: 'base.700',
        }}
        sx={{
          svg: {
            fontSize: 22,
            color: 'brand.cyan',
          },
        }}
        {...restProps}
      >
        <Text flexGrow='1' textAlign='left' ml={2}>
          {children}
        </Text>
      </Button>
    </NavLink>
  );
};
